import { toastr as reduxToastr } from "react-redux-toastr";

export const SUCCESS_TOAST_TIMEOUT_MS = 1000;

export const toastr = {
  ...reduxToastr,
  success: (title, message, options = {}) =>
    reduxToastr.success(title, message, {
      ...options,
      timeOut: SUCCESS_TOAST_TIMEOUT_MS,
      removeOnHover: false,
    }),
};
